import React, { useState } from "react";
import "./Feature.css";
import sampleImage from "../Assests/map4.jpeg";
import { AiOutlineClose } from "react-icons/ai"; // Close Button Icon

const Feature = () => {
  const [showModal, setShowModal] = useState(false);

  // Function to Open Modal
  const handleOpenModal = () => {
    setShowModal(true);
    document.body.style.overflow = "hidden"; // Prevent scrolling when modal is open
  };

  // Function to Close Modal
  const handleCloseModal = () => {
    setShowModal(false);
    document.body.style.overflow = "auto"; // Enable scrolling when modal closes
  };

  return (
    <div className="feature-container">
      {/* Left Image Section */}
      <div className="feature-image-wrapper">
        <div className="background-box"></div>
        <img src={sampleImage} alt="Featured Post" className="feature-image" />
        <span className="feature-tag">Our presence</span>
      </div>

      {/* Right Text Section */}
      <div className="feature-content">
        <h2 className="feature-title">CURRENTLY PRESENT AT</h2>
        <p className="feature-text">
          HospiPharma has a strong presence in Karnataka, including Raichur,
          Bagalkot, Ballari, Hassan, and Udupi, providing quality hospital
          pharmacy services. We focus on accessibility, affordability, and
          expanding pharmaceutical care in tier 2 and 3 cities while bridging
          the urban-rural healthcare gap.
        </p>
        <div className="feature-divider"></div>
        <button className="feature-btn" onClick={handleOpenModal}>
          READ MORE
        </button>
      </div>

      {/* ✅ MODAL (POPUP) */}
      {showModal && (
        <div className="modal-overlay" onClick={handleCloseModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            {/* Close Button */}
            <div className="modal-close-icon" onClick={handleCloseModal}>
              <AiOutlineClose size={24} />
            </div>

            {/* Modal Title */}
            <h2 className="modal-title">CURRENTLY PRESENT AT</h2>

            {/* Large Description */}
            <p className="modal-description">
              ✅ **HospiPharma** has a strong presence in **Karnataka**,
              especially in **Raichur, Bagalkot, and Ballari**. Our primary
              mission is to provide high-quality pharmaceutical products and
              services to hospitals in **tier 2 and tier 3 cities**.
              <br />
              <br />
              Our goal is to **reduce the gap** between urban and rural
              healthcare by ensuring every hospital in remote areas has access
              to the same level of care as large cities.
              <br />
              <br />
              **Our Values:** - ✅ Affordable Healthcare. - ✅ Fast Deliveries.
              - ✅ Quality Medications. - ✅ Nationwide Reach.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default Feature;
